(function () {
  if (window.__cgOkendoBooted) return;
  window.__cgOkendoBooted = true;

  var OKENDO_API_BASE = 'https://api.okendo.io/v1/stores/';

  function getProductHandle() {
    var match = window.location.pathname.match(/\/products\/([^/?#]+)/);
    return match ? match[1] : '';
  }

  function resolveProductIdSync(section) {
    var meta = section.querySelector('[data-cg-product-meta]');
    if (meta && meta.dataset.cgProductMeta) {
      return meta.dataset.cgProductMeta;
    }

    if (section.dataset.cgProductId) {
      return section.dataset.cgProductId;
    }

    var productInfo = document.querySelector('.product-form[data-product-id]');
    if (productInfo && productInfo.dataset.productId) {
      return productInfo.dataset.productId;
    }

    var analyticsProduct = window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.product;
    if (analyticsProduct && analyticsProduct.id) {
      return String(analyticsProduct.id);
    }

    return '';
  }

  function fetchProductIdFromHandle(handle) {
    if (!handle) return Promise.resolve('');

    return fetch('/products/' + encodeURIComponent(handle) + '.js')
      .then(function (response) {
        if (!response.ok) throw new Error('product js failed');
        return response.json();
      })
      .then(function (data) {
        return data && data.id ? String(data.id) : '';
      });
  }

  function resolveProductId(section) {
    var syncId = resolveProductIdSync(section);
    if (syncId) return Promise.resolve(syncId);
    return fetchProductIdFromHandle(getProductHandle());
  }

  function resolveProductUrl(section) {
    if (section.dataset.cgProductUrl) return section.dataset.cgProductUrl;
    var handle = getProductHandle();
    return handle ? '/products/' + handle : '';
  }

  function initGallery(section) {
    if (!section || section.dataset.cgInit === '1') return;

    var sectionId = section.dataset.cgSectionId || section.id.replace('section-id-', '');
    var lb = document.getElementById('cg-lightbox-' + sectionId);
    var grid = section.querySelector('[data-cg-grid]');
    var scrollNext = section.querySelector('[data-cg-scroll-next]');
    var tiles = [];
    var photos = [];
    var current = 0;
    var lbImg, lbCaption, lbLink;

    function hideSection() {
      var shopifySection = section.closest('.shopify-section');
      if (shopifySection) shopifySection.style.display = 'none';
      if (lb) lb.setAttribute('hidden', '');
    }

    function getPhotoFromTile(tile) {
      var img = tile.querySelector('.cg__img');
      var displaySrc = tile.dataset.cgDisplaySrc || (img && (img.dataset.cgDisplaySrc || img.currentSrc || img.src)) || '';
      var fullSrc = tile.dataset.cgFullSrc || (img && (img.dataset.cgFullSrc || displaySrc)) || displaySrc;
      return {
        src: fullSrc,
        displaySrc: displaySrc,
        alt: img ? img.alt : '',
        caption: tile.dataset.cgCaption || '',
        link: tile.dataset.cgLink || ''
      };
    }

    function refreshTiles() {
      tiles = Array.from(section.querySelectorAll('[data-cg-tile]'));
      photos = tiles.map(function (tile) {
        return getPhotoFromTile(tile);
      });
    }

    function createTile(photo, index) {
      var tile = document.createElement('button');
      tile.className = 'cg__tile';
      tile.type = 'button';
      tile.setAttribute('aria-label', 'View photo ' + (index + 1));
      tile.dataset.cgTile = String(index);
      tile.dataset.cgCaption = photo.caption || '';
      tile.dataset.cgLink = photo.link || '';
      tile.dataset.cgSource = photo.source || 'okendo';

      var img = document.createElement('img');
      img.className = 'cg__img';
      img.loading = index < 4 ? 'eager' : 'lazy';
      img.alt = photo.alt || photo.caption || 'Customer photo';
      img.src = photo.displaySrc || photo.src;
      img.dataset.cgDisplaySrc = photo.displaySrc || photo.src;
      img.dataset.cgFullSrc = photo.src;
      img.height = parseInt(section.dataset.cgTileHeight, 10) || 280;
      tile.appendChild(img);
      return tile;
    }

    function renderPhotos(photoList) {
      if (!grid) return;
      grid.innerHTML = '';
      photoList.forEach(function (photo, index) {
        grid.appendChild(createTile(photo, index));
      });
      refreshTiles();
      bindTileClicks();
      updateScrollNext();
      section.dataset.cgReady = '1';
    }

    function scrollToNextTile(e) {
      if (e) {
        e.preventDefault();
        e.stopPropagation();
      }
      if (!grid || !tiles.length) return;

      var visibleRight = grid.scrollLeft + grid.clientWidth;
      var target = null;

      for (var i = 0; i < tiles.length; i++) {
        var tileRight = tiles[i].offsetLeft + tiles[i].offsetWidth;
        if (tileRight > visibleRight + 2) {
          target = tiles[i];
          break;
        }
      }

      if (!target) return;

      grid.style.scrollSnapType = 'none';
      grid.scrollTo({ left: target.offsetLeft, behavior: 'smooth' });
      window.setTimeout(function () {
        grid.style.scrollSnapType = '';
        updateScrollNext();
      }, 350);
    }

    function updateScrollNext() {
      if (!scrollNext || !grid) return;
      var atEnd = grid.scrollLeft + grid.clientWidth >= grid.scrollWidth - 4;
      scrollNext.hidden = atEnd || tiles.length === 0;
    }

    function show(index) {
      if (!lb || !photos.length) return;
      current = (index + photos.length) % photos.length;
      var p = photos[current];
      lbImg.src = p.src;
      lbImg.alt = p.alt;
      lbCaption.textContent = p.caption;
      if (p.link) {
        lbLink.href = p.link;
        lbLink.removeAttribute('hidden');
      } else {
        lbLink.setAttribute('hidden', '');
      }
      lb.removeAttribute('hidden');
      document.body.style.overflow = 'hidden';
      lb.querySelector('.cg__lb-close').focus();
    }

    function close() {
      if (!lb) return;
      lb.setAttribute('hidden', '');
      document.body.style.overflow = '';
    }

    function bindTileClicks() {
      tiles.forEach(function (tile) {
        tile.addEventListener('click', function () {
          show(parseInt(tile.dataset.cgTile, 10));
        });
      });
    }

    function bindGridDrag() {
      if (!grid) return;
      var isDown = false;
      var startX = 0;
      var scrollLeft = 0;
      var didDrag = false;

      grid.addEventListener('mousedown', function (e) {
        isDown = true;
        didDrag = false;
        grid.classList.add('is-dragging');
        startX = e.pageX - grid.offsetLeft;
        scrollLeft = grid.scrollLeft;
      });

      grid.addEventListener('mouseleave', function () {
        isDown = false;
        grid.classList.remove('is-dragging');
      });

      grid.addEventListener('mouseup', function () {
        isDown = false;
        grid.classList.remove('is-dragging');
      });

      grid.addEventListener('mousemove', function (e) {
        if (!isDown) return;
        e.preventDefault();
        var x = e.pageX - grid.offsetLeft;
        if (Math.abs(x - startX) > 5) didDrag = true;
        grid.scrollLeft = scrollLeft - (x - startX) * 1.5;
      });

      grid.addEventListener('click', function (e) {
        if (didDrag) {
          e.preventDefault();
          e.stopPropagation();
        }
      }, true);
    }

    function bindLightbox() {
      if (!lb) return;
      lbImg = lb.querySelector('.cg__lb-img');
      lbCaption = lb.querySelector('[data-cg-caption]');
      lbLink = lb.querySelector('[data-cg-link]');

      lb.querySelectorAll('[data-cg-close]').forEach(function (el) {
        el.addEventListener('click', close);
      });

      lb.querySelector('[data-cg-prev]').addEventListener('click', function () {
        show(current - 1);
      });

      lb.querySelector('[data-cg-next]').addEventListener('click', function () {
        show(current + 1);
      });

      document.addEventListener('keydown', function (e) {
        if (lb.hasAttribute('hidden')) return;
        if (e.key === 'Escape') close();
        if (e.key === 'ArrowLeft') show(current - 1);
        if (e.key === 'ArrowRight') show(current + 1);
      });
    }

    function getManualPhotos() {
      var template = document.getElementById('cg-manual-' + sectionId);
      if (!template || !template.content) return [];

      return Array.from(template.content.querySelectorAll('.cg__tile')).map(function (tile) {
        var photo = getPhotoFromTile(tile);
        photo.source = 'manual';
        return photo;
      });
    }

    function normalizeOkendoMedia(item, productUrl) {
      var urls = item.imageUrls || {};
      var displaySrc = urls.largeUrl || urls.fullSizeUrl || '';
      var fullSrc = urls.fullSizeUrl || urls.largeUrl || '';
      if (!displaySrc || item.type !== 'image') return null;

      return {
        src: fullSrc,
        displaySrc: displaySrc,
        alt: item.imageAlt || 'Customer photo',
        caption: item.imageAlt || '',
        link: productUrl || '',
        source: 'okendo',
        streamId: item.streamId || ''
      };
    }

    function fetchOkendoMedia(userId, productId, maxPhotos, productUrl) {
      var photos = [];
      var seen = {};
      var storeBase = OKENDO_API_BASE + encodeURIComponent(userId);
      var nextPath = storeBase + '/products/shopify-' + productId + '/review_media?limit=25';

      function fetchPage(url) {
        // Okendo's Storefront API works without the version header. Sending
        // okendo-api-version triggers a CORS preflight that the API does not
        // allow from the browser, which breaks client-side fetches.
        return fetch(url).then(function (response) {
          if (!response.ok) throw new Error('Okendo request failed');
          return response.json();
        });
      }

      function collect(data) {
        (data.media || []).forEach(function (item) {
          if (photos.length >= maxPhotos) return;
          if (item.streamId && seen[item.streamId]) return;
          var photo = normalizeOkendoMedia(item, productUrl);
          if (!photo) return;
          if (item.streamId) seen[item.streamId] = true;
          photos.push(photo);
        });

        if (photos.length >= maxPhotos || !data.nextUrl) {
          return photos;
        }

        var nextUrl = data.nextUrl;
        if (nextUrl.indexOf('http') === 0) {
          return fetchPage(nextUrl).then(collect);
        }
        if (nextUrl.indexOf('/stores/') === 0) {
          return fetchPage('https://api.okendo.io/v1' + nextUrl).then(collect);
        }
        return fetchPage(storeBase + nextUrl).then(collect);
      }

      return fetchPage(nextPath).then(collect);
    }

    function finalize(photoList) {
      var minPhotos = parseInt(section.dataset.cgMinPhotos, 10) || 5;
      section.classList.remove('cg--loading');

      if (photoList.length < minPhotos) {
        hideSection();
        return;
      }

      renderPhotos(photoList);
    }

    function loadOkendo(productId, productUrl) {
      if (grid) grid.innerHTML = '';
      section.dataset.cgProductId = productId;
      section.dataset.cgProductUrl = productUrl;
      section.classList.add('cg--loading');

      var maxPhotos = parseInt(section.dataset.cgMaxPhotos, 10) || 12;
      var dataSource = section.dataset.cgDataSource || 'hybrid';

      fetchOkendoMedia(section.dataset.cgOkendoUserId, productId, maxPhotos, productUrl)
        .then(function (okendoPhotos) {
          var combined = okendoPhotos.slice();

          if (dataSource === 'hybrid' && combined.length < maxPhotos) {
            getManualPhotos().forEach(function (manualPhoto) {
              if (combined.length >= maxPhotos) return;
              combined.push(manualPhoto);
            });
          }

          finalize(combined);
        })
        .catch(function () {
          if (section.dataset.cgDataSource === 'hybrid') {
            finalize(getManualPhotos());
          } else {
            section.classList.remove('cg--loading');
            hideSection();
          }
        });
    }

    section.dataset.cgInit = '1';
    bindGridDrag();
    bindLightbox();

    if (scrollNext && grid) {
      scrollNext.addEventListener('click', scrollToNextTile);
      grid.addEventListener('scroll', updateScrollNext, { passive: true });
      window.addEventListener('resize', updateScrollNext);
    }

    if (section.dataset.cgOkendoUserId) {
      resolveProductId(section).then(function (productId) {
        if (!productId) {
          section.classList.remove('cg--loading');
          hideSection();
          return;
        }
        loadOkendo(productId, resolveProductUrl(section));
      });
      return;
    }

    refreshTiles();

    if (tiles.length < (parseInt(section.dataset.cgMinPhotos, 10) || 5)) {
      hideSection();
      return;
    }

    bindTileClicks();
    window.setTimeout(updateScrollNext, 100);
    section.dataset.cgReady = '1';
  }

  function initAll(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-cg-section]').forEach(function (section) {
      section.dataset.cgInit = '';
      initGallery(section);
    });
  }

  function boot() {
    initAll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (!event.target) return;
    initAll(event.target);
  });
})();
